import { getIncrementalFieldName } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/helpers/getIncrementalFieldName'
import { useMemo } from 'react'

import { IForm } from 'core-components/classes/models/IForm'

interface IUseIncremental<T> {
  formData: T
  initialData?: T
}

export const useIncremental = <T extends IForm>({ formData, initialData }: IUseIncremental<T>) => {
  const incrementalFieldNameByValueType = useMemo(() => {
    return `incremental${formData?.valueType}`
  }, [formData?.valueType])

  const incrementalFieldName = useMemo(() => {
    return getIncrementalFieldName({
      incrementalFieldNameByValueType,
      currency: formData?.currency,
      initType: formData?.initType,
    })
  }, [incrementalFieldNameByValueType, formData?.currency, formData?.initType])

  const incrementalInitialValue = useMemo(() => {
    return initialData?.[incrementalFieldName]
  }, [incrementalFieldName, initialData])

  const isIncrementalRequired = useMemo(() => {
    return formData?.shouldAddToBridges
  }, [formData?.shouldAddToBridges])

  return { incrementalInitialValue, isIncrementalRequired, incrementalFieldNameByValueType }
}
